
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/donation",
      function () {
        return require("private-next-pages/community/donation/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community/donation"])
      });
    }
  